// Storage helpers for Halloween modal/banner persistence.
// Uses localStorage by default; if Capacitor Preferences becomes available later,
// this module can be swapped without changing call sites.

type BooleanKey = 'halloween_permanently_dismissed' | 'halloween_session_suppressed';

const KEYS: Record<'PERMA' | 'SESSION', BooleanKey> = {
  PERMA: 'halloween_permanently_dismissed',
  SESSION: 'halloween_session_suppressed',
};

function readBoolean(key: BooleanKey): boolean {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
    return raw === 'true';
  } catch {
    return false;
  }
}

function writeBoolean(key: BooleanKey, value: boolean): void {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(key, value ? 'true' : 'false');
    }
  } catch {
    // no-op
  }
}

function removeKey(key: BooleanKey): void {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(key);
    }
  } catch {
    // no-op
  }
}

export function getHalloweenPermanentlyDismissed(): boolean {
  return readBoolean(KEYS.PERMA);
}

export function setHalloweenPermanentlyDismissed(value: boolean): void {
  writeBoolean(KEYS.PERMA, value);
}

export function getHalloweenSessionSuppressed(): boolean {
  return readBoolean(KEYS.SESSION);
}

export function setHalloweenSessionSuppressed(value: boolean): void {
  writeBoolean(KEYS.SESSION, value);
}

export function clearHalloweenSessionSuppressed(): void {
  removeKey(KEYS.SESSION);
}


